import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-redirect',
  templateUrl: './external-redirect.component.html',
  styleUrls: ['./external-redirect.component.scss']
})
export class ExternalRedirectComponent implements OnInit {

  constructor() {
    window.location.href = 'https://omp.uca.edu.ar/index.php/iics/index';
   }

  ngOnInit(): void {
  }

}
